import * as d3 from "d3";
import _ from "underscore";

export function textCrawler(parentElement, incData){
	var self = {};
	var parent;
	var data;

	const slideHeight = 50; //of slide!

    const blue = "steelblue";
    const green = "green";
    const purple = "purple";

	function getCurrentChapterColor(chapter) {
		let chapterColor;
	    switch (chapter){
	    	case 1:
				chapterColor=purple;	
			    break;
	    	case 2:
				chapterColor=blue;	
			    break;
		    case 3:
				chapterColor=green;	
			    break;
	    }
	    return chapterColor;
	}

	self.init = function() {

		parent=parentElement;
		data=incData;

		const textData = data.map(function(datum) {
			const obj = {};
			obj.narrative = datum.narrative;
			return obj;
		});
		// textData.reverse();

		const sliderContainer = d3.select(parent)
		  .append("div")
		  .attr("id", "slide-container")
		  .style("position", "relative")
		  .style("width", "100%")
		  // .style("height", (slideHeight*6)+"px"); // the `6` magic number is for the number of slides in the first chapter

		const slide = d3.select("#slide-container").selectAll("div")
		  .data(data)
         .enter().append("div")
          .attr("class", "slide")
          .style("position", "absolute")
		  .style("bottom", function(d, i) { return (((i*slideHeight)*(-1))+"px") }) //this is correct sizing, putting in magic number for purposes of Athena timeline
		  .style("height", slideHeight+"px")
		  .style("width", "100%")
		  .append("p").html(function(d) { return d.narrative; });

		// textData.forEach(function(datum, i) {
			// const slide = d3.select("#slide-container").append("div").attr("class", "slide");

			// slide.style("position", "absolute")
			//   .style("bottom", ((i*height)*(-1))+"px")
			//   .style("height", height+"px")
			//   .style("width", "100%")
				// slide.append("p").html(datum.narrative);
			  // .append("p").html(function(d) { return d.narrative; })
		// });

	};

	self.move = function(i) {
		const sliderContainer = d3.select("#slide-container");

		sliderContainer.style("bottom", ((i*slideHeight))+"px");
	}

	self.data = function(currentChapter, currentIndex) {

		const activeColor = getCurrentChapterColor(currentChapter);
	
		const invisibleSlides = d3.selectAll(".slide").filter(function(d) {return d.chapter !== currentChapter; });
		invisibleSlides.style("opacity", 0).style("visibility", "hidden")
		// .style("display", "none")
		.classed("inviz", true);

		const visibleSlides = d3.selectAll(".slide").filter(function(d) {return d.chapter == currentChapter; });
		visibleSlides.style("opacity", 1).style("visibility", "visible")
		// .style("display", "block")
		.classed("inviz", false);

		const activeSlide = d3.selectAll(".slide").filter(function(d) {return d.key == currentIndex; });
		activeSlide.classed("active-slide", true).style("color", activeColor);

		const invisibleActiveSlides = d3.selectAll(".slide").filter(function(d) {return d.key > currentIndex; });
		invisibleActiveSlides.style("opacity", 0).style("visibility", "hidden")
		// .style("display", "none")
		.classed("inviz", true);

	    const inactiveSlides = d3.selectAll(".slide").filter(function(d) {return d.key !== currentIndex; });
		inactiveSlides.classed("active-slide", false).style("color", "#A7A9AC");

	}

	return self;
};


/** WEBPACK FOOTER **
 ** ./src/components/text-crawler.js
 **/